;['en-US'].forEach(function (locale) {
  'use strict'

  /**
   * I18n (internationalization) data for `AppBase`.
   *
   * @namespace window.Opal.I18n.app_base
   */
  /**
   * I18n (internationalization) data for `AppBase` components.
   *
   * @namespace window.Opal.I18n.app_base.components
   */
  window.Opal.I18n = window.Opal.I18n || {}
  window.Opal.I18n[locale] = {
    translation: {
      app_base: {
        components: {},
      },
    },
  }
})
